"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan on 10/27/2016.
 */
var core_1 = require("@angular/core");
/**
 * SelectItemDirective for initializing list options (ComboBox, SelectList, Menu etc.).
 * Gets as input:
 *      data - The array of objects, which contains options data.
 *      value - The option value.
 *      name - The option name.
 *      group - The group of item.
 *      isEnabled - If item is enabled.
 *      valueField - The value field name.
 *      nameField - The name field name.
 *      groupField - The criteria name of grouping.
 *      isEnabledField - The enabled field name.
 * The valueField, the nameField, the groupField and the isEnabledField can be used only with data.
 */
var SelectItemDirective = /** @class */ (function () {
    function SelectItemDirective() {
        /**
         * The property of menu item, determining is it enabled.
         * @type {boolean}
         */
        this.isEnabled = true;
    }
    /**
     * Updates the items.
     * @param {SimpleChanges} changes - The map of component changed input fields.
     */
    SelectItemDirective.prototype.ngOnChanges = function (changes) {
        var currentData = changes['data'];
        var currentValue = changes['value'];
        var currentName = changes['name'];
        var currentGroup = changes['group'];
        var currentIsEnabled = changes['isEnabled'];
        var currentGroupField = changes['groupField'];
        if (currentData || currentValue || currentName
            || currentGroup || currentIsEnabled || currentGroupField) {
            this.parent && this.parent.onItemsChanged();
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SelectItemDirective.prototype, "data", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SelectItemDirective.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "name", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "group", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SelectItemDirective.prototype, "isEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "valueField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "nameField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "groupField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectItemDirective.prototype, "isEnabledField", void 0);
    SelectItemDirective = __decorate([
        core_1.Directive({
            selector: "sis-select-item, sis-select-items"
        })
    ], SelectItemDirective);
    return SelectItemDirective;
}());
exports.SelectItemDirective = SelectItemDirective;
//# sourceMappingURL=sis-select-item.directive.js.map